import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Fab from '@mui/material/Fab'
import {findGlobalIndex} from './utils'
 
const useStyles = makeStyles(linkStyles)

export default function QuestionLink ({section, sections, context, question, index}) {

  const classes = useStyles()
  const {answers = {}} = context.quizAssessmentToTake
  const answer = answers[question.id] || {}

  const selected = question.id == context.questionId && section.id == context.sectionId

  const marked = answer.pending == true
  const answered = answer.completed && !marked

  const onClick = e => selected && e.preventDefault()
  const className = clsx(classes.root, {selected, marked, answered})
  const href = '#' + context.link({sectionId: section.id, questionId: question.id}) 

  const globalIndex = findGlobalIndex(question.id, sections)

  return (
    <Fab {...{size: 'small', onClick, className, href}}>
      {globalIndex + 1}
    </Fab>
  )
}

export function QuestionLinkDummy () {
  const classes = useStyles()
  return (
    <Fab size="small" className={clsx(classes.root, "dummy")}>0</Fab>
  )
}

function linkStyles (theme) {
  return {
    root: {
      backgroundColor: '#f3f4f6',
      color: '#a3aab0',
      boxShadow: 'none',
      marginRight: 10,
      "& .MuiFab-label": {
        paddingTop: 2
      },
      "&:last-child": {
        marginRight: 0
      },
      "&.dummy": {
        visibility: 'hidden'
      },
      "&.marked": {
        backgroundColor: '#ef0e0a',
        color: '#fff',
      },
      "&.answered": {
        backgroundColor: '#52aa5e',
        color: '#fff',
      },
      "&.selected": {
        backgroundColor: '#000',
        color: '#fff',
        cursor: 'default'
      }
    }
  }
}
